const NAV_KEY = "famdashfun.pwa.lastNav";
const NAV_STATE_KEY = "famdashfun.pwa.navState";
const RECOVERY_VERSION_KEY = "famdashfun.pwa.recoveryVersion";
const RECOVERY_VERSION = "3";

function safeGet(key: string) {
  try { return window.localStorage.getItem(key); } catch { return null; }
}

function safeSet(key: string, value: string) {
  try { window.localStorage.setItem(key, value); } catch {}
}

function safeRemove(key: string) {
  try { window.localStorage.removeItem(key); } catch {}
}

/**
 * Installed iOS apps keep their own persistent storage. Version 3 deliberately
 * clears all legacy navigation/recovery keys once so a device that was already
 * trapped in the crash screen gets a genuinely clean Home boot after deploy.
 * This runs before React mounts and does not touch authentication or family data.
 */
export function prepareInstalledPwaStartup() {
  const previousVersion = safeGet(RECOVERY_VERSION_KEY);
  safeRemove(NAV_STATE_KEY);

  if (previousVersion !== RECOVERY_VERSION) {
    safeRemove(NAV_KEY);
    safeRemove("famdashfun.lastCrashRecovery");
    safeRemove("famdashfun.pwa.pendingNav");
    safeSet(RECOVERY_VERSION_KEY, RECOVERY_VERSION);
  }
}
